export default "__VITE_ASSET__8$2gq6Ee__"